import React from 'react'
import { Link } from 'react-router-dom'

const CourseAsideHero = ({heading,title,content,image, btnText_1,btnText_2}) => {
    return (
        <div className="aside-container">
          <aside className="aside-container-aside">
            {/* <div className="aside-tag">
              <hr className="aside-tag-hr" />
              <h2 className="aside-tag-heading">
                Top 5 Causes of Traffic Decline and How to Address Them
              </h2>
            </div> */}
            
            <h2 className="aside-heading">{title}</h2>
            <h1 className="aside-sub-heading">{heading}</h1>
            <p className="aside-content">
            {content}
            </p>
            <div className='button-text-main'>
            <Link to='/enroll-now' className='link' >
            <button className='button-text-1'>{btnText_1}</button>
            </Link>
            <Link to="/contact" className='link'>
            <button className='button-text-2'>{btnText_2}</button>
            </Link>
            </div>
            
          </aside>
          <img src={image} alt="homeimage" />
          
        </div>
      )
}

export default CourseAsideHero